export default {
    home: {
        initializing: '正在初始化系统...',
        fetchingToken: '正在获取安全令牌...',
        loadingBusiness: '正在加载业务系统...',
        connectFailed: '系统连接失败，请检查网络或联系管理员'
    },
    sso: {
        redirecting: '正在进行安全跳转...'
    },
    tutor: {
        title: "AI 教练",
        buttonTitle: "AI 教练",
        historyTitle: "对话历史",
        introduction: "我是Mark Simos的AI教练，你想了解什么？",
        description: "我可以汇总分散在各报告中的数据，解释游戏规则与经营指标，并结合 P0（阶段 0）数据举例讲解工具和分析方法；不提供具体决策建议。",
        suggestionsTitle: "你可以这样问：",
        checkCategory: "决策检查",
        checkQuestion: "当前出厂价与促销预算是否匹配？",
        historyCategory: "历史对比",
        historyQuestion: "比较产品在已完成阶段的定价变化",
        riskCategory: "风险提示",
        riskQuestion: "哪些定价输入可能引发预算或渠道风险？",
        nextCategory: "下一步",
        nextQuestion: "进入审核前还需要确认哪些事项？",
        trustNote: "AI分析仅供参考，不对决策结果负责，请谨慎使用",
        inputPlaceholder: "输入你的问题…",
        currentCompany: "当前公司",
        close: "关闭 AI 教练",
        showHistory: "展开对话历史",
        hideHistory: "收起对话历史",
        myConversations: "我的对话",
        teamShared: "团队共享",
        teamNoteTitle: "团队共享说明",
        teamNote: "同组成员可以查看团队问答。",
        today: "今天",
        lastWeek: "过去 7 天",
        earlier: "更早",
        period: "阶段 {period}",
        conversationEmpty: "向 AI 教练提一个问题...",
        noQuestions: "暂无问题"
    },
    history: {
        // {n} = 手机尾号4位
        askerMine: '我 (学员{n})',
        askerOther: '学员{n}'
    },
    chat: {
        me: '我',
        like: '点赞',
        dislike: '点踩',
        thinkingProcess: '思考过程',
        thinking: '思考中...',
        inputPlaceholder: '输入消息...',
        send: '发送',
        loadingHistory: '正在加载历史...',
        newMessage: '新消息',
        sendFailed: '[发送失败] ',
        requestTimeout: 'AI 响应超时，请重新提问。'
    },
    socratic: {
        thinkTitle: 'AI 教练 · 想一想',
        yourAnswer: '你的回答',
        teamAnswer: '队友的回答',
        closeCountdown: '{seconds} 秒后可关闭',
        skip: '跳过',

        answerPlaceholder: '输入你的想法...',
        send: '发送',
        waitingPeer: '等待队友回答...',
        close: '关闭'
    },
    facilitator: {
        title: '讲师 — AI 问答',
        seminarLabel: '研讨会',
        loading: '加载中...',
        loadFailed: '数据加载失败',
        noSeminar: '未指定研讨会',
        empty: '暂无符合筛选条件的问答记录',
        team: '团队',
        period: '阶段',
        triggeredBy: '触发于',
        question: 'AI 提问',
        answer: '学员回答',
        answeredBy: '回答人',
        unanswered: '尚未回答',
        refresh: '刷新',
        questionCount: '{n} 个问题',
        chatTab: 'AI 对话',
        socraticTab: 'AI 主动问答',
        allTeams: '全部团队',
        allPeriods: '全部阶段',
        studentQuestion: '学员提问',
        aiAnswer: 'AI 回复',
        automaticTrigger: '自动触发',
        noReply: '暂无 AI 回复',
        emptyQuestion: '无文本问题',
        export: '导出课程问答',
        partialWarning: '部分问答未能读取，导出将仅包含已加载的数据。请刷新重试以获取完整记录。',
        teamId: '团队 ID',
        recordType: '记录类型',
        student: '学员',
        createdAt: '提问时间',
        questionContent: '提问内容',
        answerContent: '回复内容',
        answeredAt: '回答时间'
    }
};
